import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
export function CountdownTimer() {
  // Start with 23:59:52
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <Section bg="dark-800" className="py-8 md:py-16 border-y border-orange-500/30" data-id="element-41">
      <div className="max-w-3xl mx-auto text-center" data-id="element-42">
        <h2 className="text-lg md:text-2xl font-bold text-white uppercase tracking-widest mb-4 md:mb-8" data-id="element-43">
          EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="flex justify-center gap-3 md:gap-8 mb-4 md:mb-8" data-id="element-44">
          <div className="flex flex-col items-center" data-id="element-45">
            <div className="w-16 h-20 md:w-28 md:h-32 bg-dark-900 border border-dark-700 rounded-xl flex items-center justify-center shadow-inner mb-1 md:mb-2" data-id="element-46">
              <span className="text-3xl md:text-6xl font-display font-bold text-orange-500" data-id="element-47">
                {formatNumber(timeLeft.hours)}
              </span>
            </div>
            <span className="text-[10px] md:text-sm text-gray-400 font-bold uppercase tracking-wider" data-id="element-48">
              Horas
            </span>
          </div>

          <div className="text-3xl md:text-6xl font-display font-bold text-dark-600 mt-3 md:mt-6" data-id="element-49">
            :
          </div>

          <div className="flex flex-col items-center" data-id="element-50">
            <div className="w-16 h-20 md:w-28 md:h-32 bg-dark-900 border border-dark-700 rounded-xl flex items-center justify-center shadow-inner mb-1 md:mb-2" data-id="element-51">
              <span className="text-3xl md:text-6xl font-display font-bold text-orange-500" data-id="element-52">
                {formatNumber(timeLeft.minutes)}
              </span>
            </div>
            <span className="text-[10px] md:text-sm text-gray-400 font-bold uppercase tracking-wider" data-id="element-53">
              Minutos
            </span>
          </div>

          <div className="text-3xl md:text-6xl font-display font-bold text-dark-600 mt-3 md:mt-6" data-id="element-54">
            :
          </div>

          <div className="flex flex-col items-center" data-id="element-55">
            <div className="w-16 h-20 md:w-28 md:h-32 bg-dark-900 border border-dark-700 rounded-xl flex items-center justify-center shadow-inner mb-1 md:mb-2" data-id="element-56">
              <span className="text-3xl md:text-6xl font-display font-bold text-orange-500" data-id="element-57">
                {formatNumber(timeLeft.seconds)}
              </span>
            </div>
            <span className="text-[10px] md:text-sm text-gray-400 font-bold uppercase tracking-wider" data-id="element-58">
              Segundos
            </span>
          </div>
        </div>

        <p className="text-base md:text-xl text-gray-300 font-medium mb-6 md:mb-8" data-id="element-59">
          Después sube <strong className="text-white" data-id="element-60">$8.000 ARS</strong> y no
          vuelve a bajar.
        </p>

        <div className="bg-dark-900 p-3 md:p-4 rounded-xl border border-dark-700 max-w-md mx-auto" data-id="element-61">
          <div className="flex justify-between text-sm font-bold mb-2" data-id="element-62">
            <span className="text-orange-500 flex items-center gap-2" data-id="element-63">
              <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" data-id="element-64"></span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-white" data-id="element-65">68% tomados</span>
          </div>
          <div className="w-full h-3 bg-dark-800 rounded-full overflow-hidden" data-id="element-66">
            <div className="h-full bg-gradient-to-r from-orange-600 to-orange-400 w-[68%] rounded-full" data-id="element-67"></div>
          </div>
        </div>
      </div>
    </Section>;
}